setTimeout (()=>{
  BSS_B2B.observer.cartSubject.listenCartCheckout()
  let cart = document.querySelector('.PageContent:has(.Cart__ItemList)');
            if ( cart) {
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                  if (m.addedNodes.length) {
                     BSS_B2B.observer.cartSubject.listenCartCheckout()
                  }
                    });
                });
                observer.observe( cart, {childList: true});
    }
}, 2500)

 document.addEventListener("cart:refresh", function () {
          BSS_B2B.observer.cartSubject.listenCartCheckout()
      });


if (window.location.pathname === '/cart') {
    let button;
    let styleTag;

    setTimeout(() => {
        function handleButtonClick(e) {
            e.preventDefault();
            button = document.querySelector(".proceed-to-checkout");
            if (button) {
                styleTag = document.createElement('style');
                styleTag.id = 'checkoutButtonStyles';
                styleTag.textContent = `
                    .cart__checkout-button {
                        pointer-events: none !important;
                        opacity: 0.6 !important;
                    }
                `;
                document.head.appendChild(styleTag);

                setTimeout(() => {
                    document.head.removeChild(styleTag);
                }, 6000);
            }
        }
        document.querySelector('.proceed-to-checkout').addEventListener('click', function (event) {
            handleButtonClick(event);
        }, true);
    }, 500);
}

